import cx from 'classnames';
import { CatBadge, CatCard } from 'components/blocks-components';
import { selectEquipment } from 'services/equipment/actions';
import { NEW_STATE } from '../../../constants';
import { handleRedirectUrlToAlp } from '../../utils';
import { ServiceInsightTabletMobileCardProps } from '../../types';
import { ServiceInsightContentDetails } from '../service-insight-details';
import styles from '../service-insight-card.module.scss';

export const ServiceTabletMobileCard = ({
  serviceInsights
}: ServiceInsightTabletMobileCardProps) => {
  const handleServiceInsightCard = async () => {
    await selectEquipment(
      serviceInsights.equipmentInfo?.id,
      serviceInsights.equipmentInfo?.serialNumber
    );
    handleRedirectUrlToAlp({
      serviceId: serviceInsights.payloadId,
      equipmentInfo: serviceInsights.equipmentInfo
    });
  };
  const isNewServiceInsight = serviceInsights.userRelatedState === NEW_STATE;
  return (
    <CatCard
      removePadding
      data-testid="cat-card"
      onClick={handleServiceInsightCard}
    >
      <div
        className={cx(`${styles['service_card']} d-flex`, {
          'ms-4': !isNewServiceInsight
        })}
      >
        {isNewServiceInsight && (
          <CatBadge
            isDot
            className={`cat-u-margin-right-sm cat-u-margin-left-sm d-flex align-items-start ${styles['service_card--new_indicator']}`}
            data-testid="cat-badge"
          />
        )}
        <ServiceInsightContentDetails
          serviceInsights={serviceInsights}
          isDesktop={false}
        />
      </div>
    </CatCard>
  );
};
